import React from 'react'
import "./Profile.css"
import Profile_tabs_and_content from './profile_tabs_and_content/Profile_tabs_and_content'
import Profile_banner from '../common_components/common_banner/profile_banner/Profile_banner'

function Profile() {
    return (
        <>
            <section className='Profile'>
                <Profile_banner imgSrc={"/assets/images/profile/profile_bg/bg.png"} heading={"PROFILE"} subHeading={"Manage your account details, track rewards, & keep your information up to date effortlessly"} />

                <Profile_tabs_and_content />
            </section>
        </>
    )
}

export default Profile